import React, { memo } from 'react';
import styles from './ItemCount.module.scss';

interface ItemCountProps {
  count: number;
  testId?: string;
}

const ItemCount: React.FC<ItemCountProps> = memo(({ count, testId }) => {
  return (
    <span className={styles.itemCount} data-testid={testId}>
      {count} {count === 1 ? 'Item' : 'Items'}
    </span>
  );
});

ItemCount.displayName = 'ItemCount';

export default ItemCount;
